import { localStg } from '@/utils/storage';

/** Get token */
export function getToken() {
  return localStg.get('token') || '';
}

/** Get temp token */
export function getTempToken(): string {
  return sessionStorage.getItem('tempToken') || '';
}

/** Set temp token */
export function setTempToken(token: string) {
  sessionStorage.setItem('tempToken', token);
}

/** Clear auth storage */
export function clearAuthStorage() {
  localStg.remove('token');
  localStg.remove('refreshToken');
  sessionStorage.removeItem('tempToken');
}
